import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbLeftArrow: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 14, ...props }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
      <g id='Box'>
        <rect fill={'none'} width='24' height='24' />
      </g>
      <g id='Final_icons_-_Common' data-name='Final icons - Common'>
        <polygon fill={fill} points='22 11 6 11 11.5 5.5 10 4 2 12 10 20 11.5 18.5 6 13 22 13 22 11' />
      </g>
    </svg>
  );
};
